//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/design-components";
import NsProductQuantitySelector from "./NsProductQuantitySelector.vue";
import "@nuskin/ns-core-styles/src/dist/main.css";

export default {
  name: "NsProductCardAction",
  components: { NsIcon, NsProductQuantitySelector },
  props: {
    /**
     * Disables the Add To Adr Button
     */
    disableAddToAdr: Boolean,
    /**
     * Disables the Add To Cart Button
     */
    disableAddToCart: Boolean,
    /**
     * Disables the Quantity Selector
     */
    disableQuantitySelector: Boolean,
    /**
     * The Exclusive Offer text
     */
    exclusiveOfferMessage: {
      type: String,
      default: ""
    },
    /**
     * Sets the max quantity for the Quantity Selector
     */
    maxQuantity: {
      type: Number,
      default: null
    },
    /**
     * Determines if the product action should have the small-width styling to support side-by-side in mobile
     */
    mobileSideBySide: Boolean,
    /**
     * Sets the quantity for the Quantity Selector
     */
    quantity: {
      type: String,
      default: "1"
    },
    /**
     * Whether to show the exclusive offer message
     */
    showExclusiveOfferMessage: Boolean,
    /**
     * Warning message, if product is out of stock or whatever
     */
    statusMessage: {
      type: String,
      default: ""
    },
    /**
     * Warning message key, for qa testing automation
     */
    statusMessageKey: {
      type: String,
      default: ""
    },
    /**
     * Translations
     */
    translations: {
      type: Object,
      required: true
    }
  },
  computed: {
    showAdrOnly() {
      return this.disableAddToCart && !this.disableAddToAdr;
    }
  },
  methods: {
    handleQuantitySelect(value, index) {
      this.$emit("quantity-select", value, index);
    },
    goToDetails() {
      this.$emit("go-to-details");
    }
  }
};
